import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

//web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyASX2Z8Rk4ulXGokLoM7r7MT1Nbw3_NGco",
  authDomain: "routeeye-auth.firebaseapp.com",
  projectId: "routeeye-auth",
  storageBucket: "routeeye-auth.firebasestorage.app",
  messagingSenderId: "341961725483",
  appId: "1:341961725483:web:c8d44f0ebf0deab0fefc6e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Configure Google provider
googleProvider.setCustomParameters({
  client_id: '341961725483-pa86rv9so1j6qgkthtbsincqsjs24gpv.apps.googleusercontent.com'
});

export { auth, googleProvider };
export default app;